import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FETCH_IN_REALIZATION } from '../../redux/InRealization';
import Table from '../../components/Table/Table';
import ScoreCell from '../Table/ScoreCell/ScoreCell';
import InRealizationCell from '../Table/ButtonsCell/InRealizationCell/InRealizationCell';
import { handleShowOffer, truncateText } from '../../helpers/utils';
import { tablesHeaders } from '../../consts/tablesConf';
import { vehicleTypes } from '../../consts/vehicleTypes';


const InRealizationTableContainer = ({ history, match, isMobile, inRealization, fetchInRealization, vehicleType, }) => {

  const handleOfferDetails = useCallback((id, whichFolder) => {
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      handleShowOffer(id, history, match, whichFolder);
    }
  }, [handleShowOffer, history, match]);


  const renderRow = (item) => {
    const formattedModel = truncateText(get(item, ['vehicle', 'model']), 17, 'right');
    const formattedCategory = truncateText(get(item, ['vehicle', 'category']), 17, 'right');

    const mobileCells = {
      [vehicleTypes.Motorbike]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'brand_name'])} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.AgriculturalMachine]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'brand_name'])} {formattedCategory}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'production_year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.Camper]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'body_mark'])} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
    };

    const desktopCells = {
      [vehicleTypes.Motorbike]: [
        <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
        <td key="model" className="cell-model">
          {formattedModel}
        </td>,
        <td key="year">{get(item, ['vehicle', 'year'])}</td>,
        <td key="id" className="cell-owners">
          {get(item, 'hash_id')}
        </td>,
        <td key="zip_code">{get(item, 'zip_code')}</td>,
        <td key="value">{get(item, 'final_price')}</td>,
        <td key="in_realization_cell" className="cell-owners">
          <InRealizationCell
            pickupDate={get(item, 'pick_up_date')}
            status={get(item, 'status')}
          />
        </td>
    ],
    [vehicleTypes.AgriculturalMachine]: [
      <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
      <td key="model" className="cell-model">
        {formattedCategory}
      </td>,
      <td key="year">{get(item, ['vehicle', 'production_year'])}</td>,
      <td key="id" className="cell-owners">
        {get(item, 'hash_id')}
      </td>,
      <td key="zip_code">{get(item, 'zip_code')}</td>,
      <td key="value">{get(item, 'final_price')}</td>,
      <td key="in_realization_cell" className="cell-owners">
        <InRealizationCell
          pickupDate={get(item, 'pick_up_date')}
          status={get(item, 'status')}
        />
      </td>
  ],
  [vehicleTypes.Camper]: [
    <td key="brand">{get(item, ['vehicle', 'body_mark'])}</td>,
    <td key="model" className="cell-model">
      {formattedModel}
    </td>,
    <td key="year">{get(item, ['vehicle', 'year'])}</td>,
    <td key="id" className="cell-owners">
      {get(item, 'hash_id')}
    </td>,
    <td key="zip_code">{get(item, 'zip_code')}</td>,
    <td key="value">{get(item, 'final_price')}</td>,
    <td key="in_realization_cell" className="cell-owners">
      <InRealizationCell
        pickupDate={get(item, 'pick_up_date')}
        status={get(item, 'status')}
      />
    </td>
  ],
  };

    return [
      <ScoreCell
        key="score"
        score={get(item, ['vehicle', 'score'])}
        photo={get(item, 'photo')} model={get(item, ['vehicle', 'model'])}
      />
    ].concat(isMobile ? mobileCells[vehicleType] : desktopCells[vehicleType]);
  };

  return (
    <Table
      whichFolder={'in_realization'}
      tableHeaders={tablesHeaders[vehicleType].in_realization}
      fetchOffers={fetchInRealization}
      totalCount={get(inRealization, 'total_count')}
      totalPages={get(inRealization, 'total_pages')}
      renderRow={renderRow}
      onRowClick={handleOfferDetails}
      items={get(inRealization, 'offers')}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    inRealization: get(state, ['inRealization']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { fetchInRealization: () => dispatch(FETCH_IN_REALIZATION()), };
};

InRealizationTableContainer.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isMobile: PropTypes.any.isRequired,
  fetchInRealization: PropTypes.func.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  inRealization: PropTypes.shape({
    total_pages: PropTypes.number,
    total_count: PropTypes.number,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InRealizationTableContainer)
